import { transferComponent } from './transfer.component';
import { stateResolver } from '../../app.state';

export const transferStateName = 'app.transfer';

export const transferState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/transfer',
    name: transferStateName,
    component: transferComponent.name,
    resolve: { stateResolver: stateResolver(transferStateName) },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/transfer/transfer.state.js